<script>
	import {onMount} from "svelte";

	export let dataMapUnit;
	export let height = null;

	import {Notebook} from '@manaakiwhenua/frag-svelte/src/index';
	import {default as mapUnitFactsheet} from '../notebooks/@ridgenb/map-unit-factsheet';

	let container;

	let width = 1024;

	function onResize() {
		if (container) {
			width = container.querySelector('[data-cell=chartAW]').getBoundingClientRect().width;
		}
	}

	$: heightOverride = height ? [['height', height]] : [];

	onMount(onResize);

	let cells = ['chartDescAW', 'chartAW', 'chartAWLegend1', 'chartAWLegend2'];
	//let cells = ['displayTextureGraph'];
	$: overrides = new Map([['dataMapUnitBar', dataMapUnit], ['width', width], ...heightOverride]);
</script>
<style>
	.aw-chart :global(.frag-notebook) {
		display: grid;
		grid-template-columns: 1fr 200px;
		grid-template-rows: auto;
		grid-template-areas:
			"chartDescAW chartDescAW"
			"chartAW chartAWLegend1"
			"chartAW chartAWLegend2"
			"chartAW chartAWLegend2";
	}

	.aw-chart :global([data-cell=chartDescAW]) {
		grid-area: chartDescAW;
	}
	.aw-chart :global([data-cell=chartAW]) {
		grid-area: chartAW;
	}

	@media screen {
		.aw-chart :global([data-cell=chartAWLegend1]) {
			padding-top: 100px;
		}
	}

	.aw-chart :global([data-cell=chartAWLegend1]) {
		grid-area: chartAWLegend1;
	}
	.aw-chart :global([data-cell=chartAWLegend2]) {
		grid-area: chartAWLegend2;
	}

	@media screen and (max-width: 640px) {
		.aw-chart :global(.frag-notebook) {
			grid-template-columns: 1fr 1fr;
			grid-template-areas:
				"chartDescAW chartDescAW"
				"chartAW chartAW"
				"chartAWLegend1 chartAWLegend2";
		}

		.aw-chart :global([data-cell=chartAWLegend1]) {
			padding-top: 0;
			text-align: right;
		}
		.aw-chart :global([data-cell=chartAWLegend2]) {
			text-align: left;
		}
	}

	@media screen and (max-width: 410px) {
		.aw-chart :global(.frag-notebook) {
			grid-template-columns: 1fr;
			grid-template-areas:
				"chartDescAW"
				"chartAW"
				"chartAWLegend1"
				"chartAWLegend2";
		}

		.aw-chart :global([data-cell=chartAWLegend1]) {
			padding-top: 0;
			text-align: left;
		}
		.aw-chart :global([data-cell=chartAWLegend2]) {
			text-align: left;
		}
	}

	@media print {
		.aw-chart {
			break-before: page;
		}
	}
</style>
<svelte:window on:resize={onResize}/>

<div class="aw-chart" bind:this={container}>
	<Notebook notebook={mapUnitFactsheet} cells={cells} overrides={overrides}></Notebook>
</div>

